exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-section[data-v-6fc3b082]{padding:6.25rem 0}.v-btn__content[data-v-6fc3b082]{color:#fff!important}", ""]);

// exports
